@if (watchdog.isParentClosed()) {
  <div class="session-closed-overlay">
    <div class="session-closed-overlay__content">
      <i class="pi pi-exclamation-triangle"></i>
      <h2>A munkamenet megszakadt</h2>
      <p>A kapcsolódó alkalmazás bezárult. Kérjük zárja be ezt az ablakot.</p>
    </div>
  </div>
} @else if (sessionExpired.isExpired()) {
  <div class="session-closed-overlay">
    <div class="session-closed-overlay__content">
      <i class="pi pi-exclamation-triangle"></i>
      <h2>A munkamenet lejárt</h2>
      <p>A munkamenete lejárt. Kérjük zárja be ezt az ablakot, és nyissa meg újból a mellékletkezelőt a szakrendszerből.</p>
    </div>
  </div>
} @else {
  <lib-attachments-handler [path]="path" [updateDocumentTitle]="true" />
}
